import { useState, useEffect } from 'react';
import axios from 'axios';
import { Tag, X } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function ContactTags({ contactId }) {
  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [newTagName, setNewTagName] = useState('');

  useEffect(() => {
    fetchTags();
    fetchAllTags();
  }, [contactId]);

  const fetchTags = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/contacts/${contactId}/tags`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTags(response.data);
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  const fetchAllTags = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/tags`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAllTags(response.data);
    } catch (error) {
      console.error('Error fetching all tags:', error);
    }
  };

  const addTag = async (tagId) => {
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${API_BASE}/dialer/contacts/${contactId}/tags/${tagId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTags();
    } catch (error) {
      console.error('Error adding tag:', error);
    }
  };

  const removeTag = async (tagId) => {
    try {
      const token = localStorage.getItem('accessToken');
      await axios.delete(
        `${API_BASE}/dialer/contacts/${contactId}/tags/${tagId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTags();
    } catch (error) {
      console.error('Error removing tag:', error);
    }
  };

  const createAndAddTag = async () => {
    if (!newTagName.trim()) return;

    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(
        `${API_BASE}/dialer/tags`,
        { name: newTagName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await addTag(response.data.id);
      setNewTagName('');
      setShowAdd(false);
      fetchAllTags();
    } catch (error) {
      console.error('Error creating tag:', error);
    }
  };

  const availableTags = allTags.filter(tag => !tags.some(t => t.id === tag.id));

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 flex-wrap">
        {tags.map((tag) => (
          <span
            key={tag.id}
            className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm"
          >
            <Tag className="w-3 h-3" />
            {tag.name}
            <button
              onClick={() => removeTag(tag.id)}
              className="hover:text-red-600"
            >
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
        {!showAdd && (
          <button
            onClick={() => setShowAdd(true)}
            className="text-blue-600 hover:text-blue-700 text-sm"
          >
            + Add Tag
          </button>
        )}
      </div>

      {showAdd && (
        <div className="flex gap-2">
          <select
            value=""
            onChange={(e) => {
              if (e.target.value) {
                addTag(e.target.value);
                setShowAdd(false);
              }
            }}
            className="flex-1 border rounded px-2 py-1 text-sm"
          >
            <option value="">Select existing tag...</option>
            {availableTags.map((tag) => (
              <option key={tag.id} value={tag.id}>
                {tag.name}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Or create new..."
            value={newTagName}
            onChange={(e) => setNewTagName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && createAndAddTag()}
            className="flex-1 border rounded px-2 py-1 text-sm"
          />
          <button
            onClick={createAndAddTag}
            className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
          >
            Add
          </button>
          <button
            onClick={() => {
              setShowAdd(false);
              setNewTagName('');
            }}
            className="px-3 py-1 border rounded text-sm hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}


